import { createApp } from "vue";
import App from "./App.vue";

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import i18n from "@/core/plugins/i18n";

//imports for app initialization
import ApiService from "@/core/services/ApiService";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";
import PrimeVue from "primevue/config";
import Dialog from "primevue/dialog";
import VueTheMask from "vue-the-mask";
import money from "v-money";
// import Select2 from "vue-select2";
import ToastService from "primevue/toastservice";

import "@/core/plugins/prismjs";
import "bootstrap";

import "primevue/resources/themes/saga-blue/theme.css";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";

// import "select2.css";
// import "select2-bootstrap-theme/dist/select2-bootstrap.min.css";
import "vue-search-select/dist/VueSearchSelect.css";

const app = createApp(App);

app.use(store);
app.use(router);
app.use(ElementPlus);
app.use(PrimeVue, {
  locale: {
    noOptions: "Nenhuma opção disponível",
    noResults: "Nenhum resultado encontrado",
    emptyMessage: "Nenhuma opção disponível",
    emptyFilterMessage: "Nenhum resultado encontrado",
  },
});
app.use(ToastService);
app.use(VueTheMask);
app.use(money, { decimal: ",", thousands: ".", precision: 2 });
// app.use(VueMask);
// eslint-disable-next-line vue/multi-word-component-names
app.component("Dialog", Dialog);
// eslint-disable-next-line vue/multi-word-component-names
// app.component("Select2", Select2);

ApiService.init(app);
initApexCharts(app);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);

app.mount("#app");
